var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "excursionInner" }, [
    _c("div", [_vm._v("Тип: " + _vm._s(_setup.props.excursion.type))]),
    _vm._v(" "),
    _c("div", [
      _setup.props.excursion.included
        ? _c("div", [_vm._v("Включено в стоимость")])
        : _c("div", [
            _vm._v("\n            Оплачивается отдельно.\n            "),
            _setup.adl_price(_setup.props.excursion) ||
            _setup.chi_price(_setup.props.excursion)
              ? _c("div", [
                  _vm._v(
                    "\n                Стоимость составляет\n                "
                  ),
                  _setup.adl_price(_setup.props.excursion)
                    ? _c(
                        "span",
                        [
                          _c(_setup.PriceCurrencyV, {
                            attrs: {
                              price: _setup.adl_price(_setup.props.excursion),
                              sum: true,
                            },
                          }),
                          _vm._v(" за взрослого, "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.chi_price(_setup.props.excursion)
                    ? _c(
                        "span",
                        [
                          _c(_setup.PriceCurrencyV, {
                            attrs: {
                              price: _setup.chi_price(_setup.props.excursion),
                              sum: true,
                            },
                          }),
                          _vm._v(" за ребенка"),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm._v(
        "Продолжительность: " +
          _vm._s(_setup.humanizeDuration(_setup.props.excursion.length))
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }